import {publisherApi} from 'common/api/entitiesApi'
import {EntitySelector} from 'common/components/reloadable/EntitySelector'

interface Props {
    value?: number
    onChange?: (value?: number) => void
    style?: React.CSSProperties
    placeholder?: string
    disabled?: boolean
    multiple?: boolean
}

export const PublisherSelector = ({ value, onChange, style, disabled, placeholder, multiple }: Props) => {
  function loadEntity(id: number) {
    return publisherApi.publisher(id)
  }

  function searchEntities(search: string, size: number, page: number) {
    return publisherApi.publisherSelectorPage('name', 'asc', search, {
        query: { size, page },
      })
  }

  return (
    <EntitySelector
      value={value}
      onChange={onChange}
      loadEntity={loadEntity}
      searchEntities={searchEntities}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      errorText="Can't load Publishers"
      multiple={multiple}
    />
  )
}
